import React from 'react';
import { useHistory } from 'react-router-dom';
import { searchParamKeys } from '../../../../shared/configs/searchParams';
import { useCurrentAcceptance } from '../../../../services/queries/acceptanceData';
import { paths } from '../../../../shared/configs/routing';

const acceptanceKey = searchParamKeys.acceptance;

const ToChangeDesksSettingsPage = () => {
  const history = useHistory();
  const acceptance = useCurrentAcceptance();

  const handleClick = (e) => {
    const { push, location } = history;

    const newParams = { [acceptanceKey]: acceptance.id };

    push({
      pathname: paths.changeDesksSettings,
      search: new URLSearchParams(newParams).toString(),
      state: {
        from: {
          location,
          acceptance,
          companyId: createCompanyId(location.search),
        },
      },
    });
  };

  return <div onClick={handleClick}>Редактировать настройку работы столов</div>;
};

export default ToChangeDesksSettingsPage;

function createCompanyId(search) {
  const params = new URLSearchParams(search);
  return Number(params.get(searchParamKeys.company));
}
